import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FileUploadAwareJsonWriterClass;
function FileUploadAwareJsonWriter() {
  if (FileUploadAwareJsonWriterClass === VOID) {
    class $ {
      constructor(wrappedWriter) {
        this.u48_1 = wrappedWriter;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.v48_1 = LinkedHashMap().bc();
      }
      w48() {
        return this.v48_1;
      }
      w41() {
        // Inline function 'kotlin.apply' call
        this.u48_1.w41();
        return this;
      }
      x41() {
        // Inline function 'kotlin.apply' call
        this.u48_1.x41();
        return this;
      }
      r41() {
        // Inline function 'kotlin.apply' call
        this.u48_1.r41();
        return this;
      }
      s41() {
        // Inline function 'kotlin.apply' call
        this.u48_1.s41();
        return this;
      }
      t48(name) {
        // Inline function 'kotlin.apply' call
        this.u48_1.t48(name);
        return this;
      }
      d42(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.d42(value);
        return this;
      }
      n42(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.n42(value);
        return this;
      }
      i42(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.i42(value);
        return this;
      }
      f42(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.f42(value);
        return this;
      }
      l42(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.l42(value);
        return this;
      }
      j4b(value) {
        // Inline function 'kotlin.apply' call
        this.u48_1.j4b(value);
        return this;
      }
      s42(value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.v48_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.u48_1.y4a();
        tmp0.x4(key, value);
        this.u48_1.w40();
        return this;
      }
      w40() {
        // Inline function 'kotlin.apply' call
        this.u48_1.w40();
        return this;
      }
      y4a() {
        return this.u48_1.y4a();
      }
      l6() {
        this.u48_1.l6();
      }
    }
    initMetadataForClass($, 'FileUploadAwareJsonWriter');
    FileUploadAwareJsonWriterClass = $;
  }
  return FileUploadAwareJsonWriterClass;
}
//region block: exports
export {
  FileUploadAwareJsonWriter as FileUploadAwareJsonWriter1mx337tg0y9oj,
};
//endregion

//# sourceMappingURL=FileUploadAwareJsonWriter.mjs.map
